module.exports = __webpack_public_path__ + "pigmentace_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/pigmentace_2_before.jpg
// module id = 972
// module chunks = 0